import { render, staticRenderFns } from "./EventInfoView.vue?vue&type=template&id=6126889f&"
import script from "./EventInfoView.vue?vue&type=script&lang=js&"
export * from "./EventInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports